import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: '',
    hasLogin: false,
    userInfo: {}
  },
  mutations: {
    login(state, { token, userInfo }) {
      state.hasLogin = true;
      state.token = token;
      state.userInfo = userInfo;
      window.localStorage.setItem('hasLogin', true)
      window.localStorage.setItem('token', token)
      window.localStorage.setItem('userInfo', encodeURIComponent(JSON.stringify(userInfo)))
    },
    refreshPage(state) { //刷新页面
      var _userInfo = JSON.parse(decodeURIComponent(window.localStorage.getItem('userInfo')));
      if(_userInfo){
        state.hasLogin = true;
        state.token = window.localStorage.getItem('token');
        state.userInfo = _userInfo;
      }
    },
    logout(state) {
      state.hasLogin = false;
      window.localStorage.removeItem('userInfo')
      window.localStorage.removeItem('hasLogin')
      window.localStorage.removeItem('token')
    }
  },
  actions: {},  //异步用不到
  modules: {}   //模块化用不到
})
